import React from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useT } from "i18n";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import {
  BackgroundColorContext,
} from "../../context/BackgroundColorContext"; 

 

var ps;

function UltraSidebar(props) {
  const { t } = useT();
  const location = useLocation();
  const sidebarRef = React.useRef(null);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebarRef.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  }, []);
  const { routes, rtlActive, logo, bgColor } = props;
  let logoImg = null;
  let logoText = null;
  if (logo !== undefined) {
    if (logo.outterLink !== undefined) {
      logoImg = (
        <a
          href={logo.outterLink}
          className="simple-text logo-mini"
          target="_blank"
          rel="noopener noreferrer"
          onClick={props.toggleSidebarDos}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="Logo Panther7" />
          </div>
        </a>
      );
      logoText = (
        <a
          href={logo.outterLink}
          className="simple-text logo-normal"
          target="_blank"
          rel="noopener noreferrer"
          onClick={props.toggleSidebarDos}
        >
          {logo.text}
        </a>
      );
    } else {
      logoImg = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-mini"
          onClick={props.toggleSidebarDos}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="Logo Panther7" />
          </div>
        </Link>
      );
      logoText = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-normal"
          onClick={props.toggleSidebarDos}
        >
          {logo.text}
        </Link>
      );
    }
  }
  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <div className="ultrasidebar-box-container" data={bgColor}>
          <div className="ultrasidebar-box" ref={sidebarRef}>
            <div className="list-cap">
              {routes.map((prop, key) => {
                if (prop.redirect) return null;
                return (
                  <div
                    className={
                      activeRoute(prop.path) + (prop.pro ? " active-pro-ultra" : "nav-ultra")
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.layout + prop.path}
                      className="nav-link-ultra"
                      activeClassName="active nav-link-ultra-active"
                      onClick={props.toggleSidebarDos}
                    >
                      <i className={prop.icon} />
                      <p>{prop.tkey ? t(prop.tkey) : prop.name}</p>
                    </NavLink>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
}

UltraSidebar.defaultProps = {
  rtlActive: false,
  routes: [{}],
};

UltraSidebar.propTypes = {
  // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
  // insde the links of this component
  rtlActive: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the text of the logo
    text: PropTypes.node,
    // the image src of the logo
    imgSrc: PropTypes.string,
  }),
};

export default UltraSidebar;